import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

// Scoring Criteria endpoints
export const getCriteria = () =>
    axios.get(`${apiUrl}ats/criteria`);

export const createCriterion = (data) =>
    axios.post(`${apiUrl}ats/criteria`, data);

export const updateCriterion = (data) =>
    axios.put(`${apiUrl}ats/criteria`, data);

export const deleteCriterion = (criterionId) =>
    axios.delete(`${apiUrl}ats/criteria/${criterionId}`);

export const getCriteriaProjection = () =>
    axios.get(`${apiUrl}ats/criteria/projection`);

// Keywords endpoints
export const getCriterionKeywords = (criterionId) =>
    axios.get(`${apiUrl}ats/criteria/${criterionId}/keywords`);

export const createKeyword = (criterionId, data) =>
    axios.post(`${apiUrl}ats/criteria/${criterionId}/keywords`, data);

export const updateKeyword = (keywordId, data) =>
    axios.put(`${apiUrl}ats/criteria/keywords/${keywordId}`, data);

export const deleteKeyword = (keywordId) =>
    axios.delete(`${apiUrl}ats/criteria/keywords/${keywordId}`);
